import PropTypes from 'prop-types';

const LoadingSpinner = ({
  size = 'large',
  color = 'primary',
  text = '',
  className = '',
  message = 'Loading...',
  variant = 'spinner',
}) => {
  const displayText = text || message;

  const renderSpinner = () => {
    switch (variant) {
      case 'dots':
        return (
          <div
            className={`exl-loading-dots exl-loading-${size} exl-loading-${color}`}
          >
            <div className="exl-dot"></div>
            <div className="exl-dot"></div>
            <div className="exl-dot"></div>
          </div>
        );

      case 'pulse':
        return (
          <div
            className={`exl-loading-pulse exl-loading-${size} exl-loading-${color}`}
          >
            <div className="exl-pulse-ring"></div>
            <div className="exl-pulse-core"></div>
          </div>
        );

      case 'bars':
        return (
          <div
            className={`exl-loading-bars exl-loading-${size} exl-loading-${color}`}
          >
            <div className="exl-bar"></div>
            <div className="exl-bar"></div>
            <div className="exl-bar"></div>
            <div className="exl-bar"></div>
          </div>
        );

      default:
        return (
          <div
            className={`exl-spinner exl-spinner-${size} exl-spinner-${color}`}
          >
            <div className="exl-spinner-ring"></div>
            <div className="exl-spinner-ring"></div>
            <div className="exl-spinner-ring"></div>
            <div className="exl-spinner-ring"></div>
          </div>
        );
    }
  };

  return (
    <div className={`exl-loading-container ${className}`}>
      {renderSpinner()}
      {displayText && <p className="exl-loading-text">{displayText}</p>}
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOf(['primary', 'secondary', 'white']),
  text: PropTypes.string,
  className: PropTypes.string,
  message: PropTypes.string, // For backward compatibility
  variant: PropTypes.oneOf(['spinner', 'dots', 'pulse', 'bars']),
};

export default LoadingSpinner;
